// extracted by mini-css-extract-plugin
module.exports = {"chartWrapper":"Chart-module--chartWrapper--3RTE9"};